import { createContext, useContext, useMemo } from 'react';

const LandingContext = createContext();

export const LandingProvider = ({
  accountName,
  actionsItems,
  arrivalLocation,
  attachedFiles,
  attachments,
  externalUrl,
  attachedImages,
  attachedVideos,
  attendees,
  cancelled = false,
  categories,
  children,
  comments,
  companyName,
  content,
  contractTypeName,
  coverPicture,
  createdAt,
  currency,
  dailySalary,
  departureLocation,
  displayCommentsByDefault,
  duration,
  embed,
  endDate,
  experienceTypeName,
  fromRecord,
  handleShare,
  handleShowUser,
  hasHeader,
  hasSocialOptions,
  id,
  isActive,
  isRowVisibleOrOutOfView,
  labelledById,
  lastContributors,
  likes,
  location,
  logo,
  logoUrl,
  measure,
  monthlySalary,
  onToggleComments,
  onTogglePostLike,
  onUpdateItem,
  originalType,
  owner,
  participantDisplayThreshold,
  pinned,
  postContent,
  publishedAt,
  shareUrl,
  startDate,
  surveyContent,
  timezone,
  title,
  topic,
  totalAttendees,
  totalComments,
  totalExternalAttendees,
  totalVisibleAttendees,
  totalVisibleYesResponses,
  transportation,
  type,
  ventureContent,
  yearlySalary,
}) => {
  const values = useMemo(
    () => ({
      accountName,
      actionsItems,
      arrivalLocation,
      attachedFiles,
      attachments,
      externalUrl,
      attachedImages,
      attachedVideos,
      attendees,
      cancelled,
      categories,
      comments,
      companyName,
      content,
      contractTypeName,
      coverPicture,
      createdAt,
      currency,
      dailySalary,
      departureLocation,
      displayCommentsByDefault,
      duration,
      embed,
      endDate,
      experienceTypeName,
      fromRecord,
      handleShare,
      handleShowUser,
      hasHeader,
      hasSocialOptions,
      id,
      isActive,
      isRowVisibleOrOutOfView,
      labelledById,
      lastContributors,
      likes,
      location,
      logo,
      logoUrl,
      measure,
      monthlySalary,
      onToggleComments,
      onTogglePostLike,
      onUpdateItem,
      originalType,
      owner,
      participantDisplayThreshold,
      pinned,
      postContent,
      publishedAt,
      shareUrl,
      startDate,
      surveyContent,
      timezone,
      title,
      topic,
      totalAttendees,
      totalComments,
      totalExternalAttendees,
      totalVisibleAttendees,
      totalVisibleYesResponses,
      transportation,
      type,
      ventureContent,
      yearlySalary,
    }),
    [
      accountName,
      actionsItems,
      arrivalLocation,
      attachedFiles,
      attachments,
      externalUrl,
      attachedImages,
      attachedVideos,
      attendees,
      cancelled,
      categories,
      comments,
      companyName,
      content,
      contractTypeName,
      coverPicture,
      createdAt,
      currency,
      dailySalary,
      departureLocation,
      displayCommentsByDefault,
      duration,
      embed,
      endDate,
      experienceTypeName,
      fromRecord,
      handleShare,
      handleShowUser,
      hasHeader,
      hasSocialOptions,
      id,
      isActive,
      isRowVisibleOrOutOfView,
      labelledById,
      lastContributors,
      likes,
      location,
      logo,
      logoUrl,
      measure,
      monthlySalary,
      onToggleComments,
      onTogglePostLike,
      onUpdateItem,
      originalType,
      owner,
      participantDisplayThreshold,
      pinned,
      postContent,
      publishedAt,
      shareUrl,
      startDate,
      surveyContent,
      timezone,
      title,
      topic,
      totalAttendees,
      totalComments,
      totalExternalAttendees,
      totalVisibleAttendees,
      totalVisibleYesResponses,
      transportation,
      type,
      ventureContent,
      yearlySalary,
    ],
  );

  return (
    <LandingContext.Provider value={values}>{children}</LandingContext.Provider>
  );
};

LandingProvider.defaultProps = {
  hasHeader: true,
};

export const useLandingContext = () => useContext(LandingContext);

export const withLandingContext = (Component) => (props) => {
  const contextValue = useLandingContext();

  return <Component {...contextValue} {...props} />;
};

export default LandingContext;
